(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-gift-cards"] && !Shopify.designMode) return;
  try {
    
function initializeGiftRegions(scope = document) {
  scope.querySelectorAll('.sfgifts').forEach(async (section) => {
    if (section.dataset.regionInitialized) return;
    section.dataset.regionInitialized = 'true';
    const form = section.querySelector('.sfgifts__region');
    const select = form?.querySelector('select[name="country_code"]');
    const note = section.querySelector('[data-gift-note]');
    if (!form || !select || window.Shopify?.designMode) return;
    let automaticSubmission = false;
    const storage = {
      get(key) { try { return sessionStorage.getItem(key); } catch { return null; } },
      set(key, value) { try { sessionStorage.setItem(key, value); } catch {} }
    };
    form.addEventListener('submit', () => {
      if (!automaticSubmission) storage.set('sfGiftManualRegion', select.value);
    });
    select.addEventListener('change', () => form.requestSubmit());
    if (storage.get('sfGiftManualRegion') === select.value) return;
    try {
      const previous = new URL(document.referrer);
      if (previous.origin === window.location.origin && previous.pathname !== '/password') {
        storage.set('sfGiftManualRegion', select.value);
        return;
      }
    } catch {}
    try {
      const url = new URL((window.Shopify?.routes?.root || '/') + 'browsing_context_suggestions.json', window.location.origin);
      url.searchParams.set('country[enabled]', 'true');
      url.searchParams.set('country[exclude]', section.dataset.giftRegion);
      url.searchParams.set('language[enabled]', 'true');
      url.searchParams.set('language[exclude]', document.documentElement.lang || 'en');
      const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(5000) });
      if (!response.ok) return;
      const data = await response.json();
      const detected = data.detected_values?.country || data.suggestions?.[0]?.parts?.country;
      if (!detected?.handle) return;
      const country = detected.handle.toUpperCase();
      section.dataset.detectedCountry = country;
      if (country === section.dataset.giftRegion) return;
      const supported = Array.from(select.options).some(option => option.value === country);
      if (!supported) {
        section.classList.add('sfgifts--unsupported');
        note.textContent = (detected.name || country) + ': ' + note.dataset.message;
        note.hidden = false;
        return;
      }
      if (storage.get('sfGiftAutomaticRegion') === country) return;
      storage.set('sfGiftAutomaticRegion', country);
      select.value = country;
      automaticSubmission = true;
      form.requestSubmit();
    } catch {}
  });
}
initializeGiftRegions();
document.addEventListener('shopify:section:load', event => initializeGiftRegions(event.target));

  } catch(e) { console.error(e); }
})();
})();
